export default function CardContentSkeleton() {
  return (
    <div className="flex flex-col gap-[10px] w-full animate-pulse">
      <div className="w-full aspect-square rounded-[4px] bg-gray-300" />
      <div className="h-5 bg-gray-300 rounded w-3/4 mt-2" />
      <div className="h-3 bg-gray-300 rounded w-full mt-1" />
      <div className="h-3 bg-gray-300 rounded w-full mt-1" />
      <div className="h-3 bg-gray-300 rounded w-full mt-1" />
    </div>
  )
}
